import React from 'react';
import { combineClassNames } from 'lib/utility';

const Button = ({
  onClick,
  disabled,
  className,
  id,
  form,
  testid,
  label,
  icon,
  type = 'primary',
}) => (
  <button
    type={form ? 'submit' : 'button'}
    className={combineClassNames(['btn btn-block', `btn-${type}`], className)}
    id={id}
    form={form || undefined}
    onClick={onClick}
    disabled={disabled}
    data-testid={testid}
  >
    {icon ? (
      <>
        <span className="me-2">
          <i className={`fa fa-${icon}`} />
        </span>
        <span>
          {label}
        </span>
      </>
    ) : (
      label
    )}
  </button>
);

export default Button;
